import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconNetwork({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      height={size || 16}
      width={size || 16}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5573 4.97607C13.9314 4.97607 15.0453 3.86214 15.0453 2.48804C15.0453 1.11393 13.9314 0 12.5573 0C11.1831 0 10.0692 1.11393 10.0692 2.48804C10.0692 2.78434 10.121 3.06855 10.216 3.33209L4.74015 6.84596C4.29048 6.39993 3.67144 6.1244 2.98804 6.1244C1.61393 6.1244 0.5 7.23833 0.5 8.61244C0.5 9.98654 1.61393 11.1005 2.98804 11.1005C3.72068 11.1005 4.37936 10.7838 4.83467 10.2799L10.1054 13.0869C10.0816 13.225 10.0692 13.367 10.0692 13.512C10.0692 14.8861 11.1831 16 12.5573 16C13.9314 16 15.0453 14.8861 15.0453 13.512C15.0453 12.1379 13.9314 11.0239 12.5573 11.0239C11.7324 11.0239 11.0013 11.4253 10.5486 12.0435L5.36219 9.35878C5.43618 9.12317 5.47607 8.87246 5.47607 8.61244C5.47607 8.32324 5.42673 8.04556 5.33601 7.78737L10.8474 4.29545C11.2932 4.71734 11.895 4.97607 12.5573 4.97607Z"
        fill={color || "#5A6072"}
      />
    </svg>
  );
}
